import { useNavigate } from "react-router-dom";
import {
  ListMenuItem,
  LeftWrapper,
  IconWrapper,
  ListDescription,
  Label,
  SubLabel,
  ChevronWrapper,
} from "./ListMenuItem.styles";
import { ChevronRightIcon } from "src/assets/icons";

interface MenuItem {
  id: string;
  path: string;
  label: string;
  subLabel: string;
  icon: React.ComponentType;
  selectedIcon: React.ComponentType;
  disabled?: boolean;
}

export default function ({
  id,
  label,
  subLabel,
  icon: Icon,
  selectedIcon: SelectedIcon,
  currentSection,
  path,
  disabled,
}: MenuItem & { currentSection: string }) {
  const navigate = useNavigate();
  const isSelected = currentSection === id;

  return (
    <ListMenuItem
      currentSelection={isSelected}
      disabled={disabled}
      onClick={() => {
        if (!disabled) void navigate(path);
      }}
    >
      <LeftWrapper>
        <IconWrapper currentSelection={isSelected}>
          {isSelected ? <SelectedIcon /> : <Icon />}
        </IconWrapper>
        <ListDescription>
          <Label>{label}</Label>
          <SubLabel>{subLabel}</SubLabel>
        </ListDescription>
      </LeftWrapper>
      <ChevronWrapper currentSelection={isSelected}>
        <ChevronRightIcon height="14" width="14" />
      </ChevronWrapper>
    </ListMenuItem>
  );
}
